require('./bootstrap');

// Import modules...
import Vue from 'vue';
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue';
import Axios from 'axios';
import PortalVue from 'portal-vue';
import VueTailwind from 'vue-tailwind';
// import { InertiaProgress } from '@inertiajs/progress';
import VueMeta from 'vue-meta';
import Echo from 'laravel-echo';
import VueHtmlToPaper from 'vue-html-to-paper';
import VueI18n from 'vue-i18n';
// import VueApexCharts from 'vue-apexcharts';
import settings from './vue-tailwind.config';
import GlobalMixins from './Mixins/GlobalMixins';
import messages from './lang';

const VueCookie = require('vue-cookie');

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true,
});

const htmlToPaperOptions = {
    name: '_blank',
    specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
    styles: ['https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css', 'public/vendor/telescope/app.css'],
    timeout: 1000, // default timeout before the print window appears
    autoClose: true, // if false, the window will not close after printing
    windowTitle: 'B2B Shop',
};

Vue.mixin(GlobalMixins);
Vue.mixin({ methods: { route } });
Vue.use(InertiaPlugin);
Vue.use(PortalVue);
Vue.use(VueTailwind, settings);
Vue.use(VueCookie);
Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true,
});

Vue.use(VueHtmlToPaper, htmlToPaperOptions);
// Vue.use(VueApexCharts);
Vue.use(VueI18n);

// Commented the bar progress and trying to use the custome progress
// InertiaProgress.init();

Vue.prototype.$axios = Axios;

const app = document.getElementById('app');

export const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages,
});

new Vue({
    i18n,
    render: (h) =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: (name) => require(`./Pages/${name}`).default,
            },
        }),
}).$mount(app);
